import api from "@/plugins/axios";
import { useUserStore } from "@/store/userStore";
import router from "@/router";

export function fetchUser() {
  const userStore = useUserStore();
  api
    .get("auth/me")
    .then((response) => {
      userStore.setUser(response.data.data);
    })
    .catch((error) => {
      // console.log(error);
      if (error.response?.status == 401) {
        localStorage.removeItem("user_token");
        userStore.setUser({});
        if (this.$route.name != "login" && this.$route.name != "register" && this.$route.meta.requireAuth) {
          router.push({ name: "login" });
          console.log("redirecting to login")
        }
      }
    });
}

export function fetchTenant(force = false) {
  const userStore = useUserStore();
  if (force) {
    getTenant();
    return;
  }
  
  if (!userStore.tenant || !userStore.tenant.id) {
    getTenant();
  } else {
    userStore.loadTenant();
  }
}

function getTenant() {
  const userStore = useUserStore();

  api
    .get("tenant/me")
    .then((response) => {
      userStore.setTenant(response.data.data);
    })
    .catch(() => {
      // console.log(error);
      userStore.setTenant({});
    });
}
